import React from 'react';
import './EmptyState.css';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  sub?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, sub, action, className = '' }: EmptyStateProps) {
  return (
    <div className={`a-empty ${className}`.trim()}>
      {icon && <div className="a-empty__icon">{icon}</div>}
      <h3 className="a-empty__title">{title}</h3>
      {sub && <p className="a-empty__sub">{sub}</p>}
      {action && <div className="a-empty__action">{action}</div>}
    </div>
  );
}
